import { render } from "./proche_s_item.vue?vue&type=template&id=4ae4ae7e&scoped=true"
import script from "./proche_s_item.vue?vue&type=script&lang=js"
export * from "./proche_s_item.vue?vue&type=script&lang=js"

import "./proche_s_item.vue?vue&type=style&index=0&id=4ae4ae7e&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae4ae7e"]])

export default __exports__